import { faStopwatch, faTrophy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { DriverLink } from "../FlagLink";
import getTextColor from "../../utils/DynamicContrast";
import { getAbbreviation } from "../../utils/Standings";
import React from "react";

const SummaryResults = ({ polemans, winners, fastestlaps }: any) => {
  const { t } = useTranslation();

  // Renderizamos pasando el objeto completo del ganador (item) en lugar de solo el índice y el nombre de clase
  const renderResultCard = (winner: any, index: number) => {
    // Buscamos el poleman y la vuelta rápida coincidiendo tanto la clase como el tipo de carrera (por si hay mezcla)
    const pole = polemans.find(
      (driver: any) =>
        driver.class_name === winner.class_name &&
        driver.type_race === winner.type_race,
    );

    const flap = fastestlaps.find(
      (driver: any) =>
        driver.class_name === winner.class_name &&
        driver.type_race === winner.type_race,
    );

    const multipleRaces = winners.some((driver: any) => driver.type_race > 1);
    const color = winner.class_color;

    return (
      <div
        key={winner.assignment_id || index}
        className={`summary-results ${index > 0 ? "margTop" : ""}`}
        style={{ borderColor: color }}
      >
        {multipleRaces && (
          <span className="racenumber">R{winner.type_race}</span>
        )}
        {winner.class_name != null && (
          <label style={{ backgroundColor: color, color: getTextColor(color) }}>
            {winner.class_name}
          </label>
        )}
        <div className="flex">
          <div>
            <div className="flex">
              <FontAwesomeIcon icon={faTrophy} />
              <div className="winner-div">
                <label>{t("Winner")}</label>
                <div>
                  <DriverLink
                    flag_code={winner.flag_code}
                    flag_name={winner.flag_name}
                    name={winner.username}
                    nickname={winner.nickname}
                    abbreviation={getAbbreviation(winner.username)}
                  />
                </div>
              </div>
            </div>
            <div className="flex second-row-stats">
              {pole != null && (
                <div>
                  <FontAwesomeIcon icon={faStopwatch} />
                  <label>{t("Pole")}</label>
                  <div>
                    <DriverLink
                      flag_code={pole.flag_code}
                      flag_name={pole.flag_name}
                      name={pole.username}
                      nickname={pole.nickname}
                      abbreviation={getAbbreviation(pole.username)}
                    />
                  </div>
                </div>
              )}
              {flap != null && (
                <div>
                  <label>{t("HotLap")}</label>
                  <div>
                    <DriverLink
                      flag_code={flap.flag_code}
                      flag_name={flap.flag_name}
                      name={flap.username}
                      nickname={flap.nickname}
                      abbreviation={getAbbreviation(flap.username)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="justify-center">
            {(winner.team_championship_id != null ||
              (winner.championship_id && winner.username)) && (
              <img
                alt={winner.username}
                title={winner.username}
                src={`/assets/TeamChampionship/Auxiliary/${winner.championship_id}_${encodeURIComponent(winner.username)}.png`}
                onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                  const target = e.currentTarget;
                  if (
                    target.src.includes("Auxiliary") &&
                    winner.team_championship_id != null
                  ) {
                    target.src = `/assets/TeamChampionship/${winner.team_championship_id}.png`;
                  } else {
                    target.style.display = "none";
                  }
                }}
              />
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <hr />
      <p className="main-title noBottomMargin frame-title">
        {t("Results").toUpperCase()}
      </p>
      {winners.map((winner: any, index: number) => {
        return renderResultCard(winner, index);
      })}
    </React.Fragment>
  );
};

export default SummaryResults;
